var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 0.666667)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90733333,3.42133333 L10.9146667,2.618 L10.4186667,1.38 L8.34066667,2.212 L9.2,1.066 C9.36933333,0.840666667 9.37866667,0.532666667 9.22266667,0.297333333 C9.06666667,0.0626666667 8.78,-0.0493333333 8.506,0.0193333333 L6,0.643333333 L3.49466667,0.0193333333 C3.22066667,-0.0486666667 2.934,0.0633333333 2.778,0.297333333 C2.622,0.532666667 2.63066667,0.840666667 2.8,1.066 L3.65933333,2.212 L1.58133333,1.38 L1.08533333,2.61866667 L3.09266667,3.422 C1.25066667,4.44666667 0,6.41266667 0,8.66666667 C0,11.9746667 2.692,14.6666667 6,14.6666667 C9.308,14.6666667 12,11.9746667 12,8.66666667 C12,6.41266667 10.7493333,4.44666667 8.90733333,3.42133333 Z M8,7.33333333 L5.66666667,7.33333333 C5.48266667,7.33333333 5.33333333,7.48266667 5.33333333,7.66666667 C5.33333333,7.85 5.48266667,8 5.66666667,8 L6.33333333,8 C7.252,8 8,8.748 8,9.66666667 C8,10.4713333 7.42666667,11.1446667 6.66666667,11.2993333 L6.66666667,12 L5.33333333,12 L5.33333333,11.3333333 L4,11.3333333 L4,10 L6.33333333,10 C6.51733333,10 6.66666667,9.85 6.66666667,9.66666667 C6.66666667,9.48266667 6.51733333,9.33333333 6.33333333,9.33333333 L5.66666667,9.33333333 C4.748,9.33333333 4,8.58533333 4,7.66666667 C4,6.86133333 4.57333333,6.18866667 5.33333333,6.034 L5.33333333,5.33333333 L6.66666667,5.33333333 L6.66666667,6 L8,6 L8,7.33333333 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.9c1511c8f63eea7a39facf0d77989467.svg";
export { ForwardRef as ReactComponent };